import httpWrapper from '../HttpWrapper'
import {
    FetchCoreSignalJobsReq,
    FetchCoreSignalJobsRes,
    FetchCoreSignalJobsPreviewRes,
    FetchCoreSignalJobDetailReq,
    FetchCoreSignalJobDetailRes,
    CreateCoreSignalJobTitlesListReq,
    CreateCoreSignalJobTitlesListRes,
} from './models/FetchCoreSignalJobsDtos'

class CoreSignalApi {
    public async fetchJobs(
        req: FetchCoreSignalJobsReq,
    ): Promise<FetchCoreSignalJobsRes> {
        return await httpWrapper.post('coresignal/jobs', req)
    }

    public async fetchJobsPreview(
        req: FetchCoreSignalJobsReq,
    ): Promise<FetchCoreSignalJobsPreviewRes> {
        return await httpWrapper.post('coresignal/jobs/preview', req)
    }

    public async fetchJobDetail(
        req: FetchCoreSignalJobDetailReq,
    ): Promise<FetchCoreSignalJobDetailRes> {
        return await httpWrapper.post('coresignal/jobs/detail', req)
    }

    public async createJobTitlesList(
        req: CreateCoreSignalJobTitlesListReq,
    ): Promise<CreateCoreSignalJobTitlesListRes> {
        return await httpWrapper.post('coresignal/jobs/title-list', req)
    }
}

const coreSignalApi = new CoreSignalApi()
export default coreSignalApi
